module.exports = __webpack_public_path__ + "img/education.37d615b8.svg";